import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BlogListingModel } from '../../models/blog-listing.model';

@Component({
  selector: 'mj-overview-single-blog-listing',
  templateUrl: './overview-single-blog-listing.component.html',
  styleUrls: ['./overview-single-blog-listing.component.scss'],
})
export class OverviewSingleBlogListingComponent implements OnInit, OnChanges {
  @Input() listing: BlogListingModel;
  @Input() access: number;

  background_image = '';
  listing_blog_link = environment.blog_url;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listing && changes.listing.currentValue) {
      const blog_link =
        environment.blog_url +
        this.listing.blog_post.category.slug +
        '/' +
        this.listing.blog_post.slug;
      const image_url = this.listing.blog_listing_items[0].background_image_url;
      if (image_url) {
        this.background_image = image_url;
      } else {
        this.background_image = '';
      }
      this.listing_blog_link = blog_link;
    }
  }

  ngOnInit() {}
}
